import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

// Hoş geldin ve kurulum adımları için ortak, mobil öncelikli küçük dialog.
export const SetupPromptDialog = ({ open, eyebrow, title, text, primary, onPrimary, onSkip, testId }) => (
  <Dialog open={open} onOpenChange={(v) => { if (!v) onSkip(); }}>
    <DialogContent className="max-w-md w-[calc(100%-2rem)] rounded-2xl" data-testid={testId}>
      {eyebrow && <div className="text-xs font-semibold tracking-wider uppercase text-[#055473]/70">{eyebrow}</div>}
      <DialogTitle className="text-xl text-slate-900 pr-8">{title}</DialogTitle>
      <DialogDescription className="text-sm text-slate-600 leading-relaxed">{text}</DialogDescription>
      <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 pt-2">
        <Button variant="outline" className="h-11" onClick={onSkip} data-testid={`${testId}-skip`}>Şimdilik Geç</Button>
        <Button className="h-11 bg-[#055473] hover:bg-[#04445d] text-white" onClick={onPrimary} data-testid={`${testId}-primary`}>
          {primary}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
